import axios from "axios";

class ContactUsApi
 {

  contactInquiry(formValues){
    if(formValues.kind == undefined) formValues.kind = "general_inquiry"
    
    const apiUrl = "/api/v1/inquiries";
    const csrfToken = document.head.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

    return axios.post(
      apiUrl, 
      {inquiry: formValues},
      {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
      }
    )
    .then(response => {
      const ok = response.status == 200;
      return Promise.resolve(ok);
    });
  }

}

export default ContactUsApi
;